// extracted by mini-css-extract-plugin
export default {"cls1":"FWhglUeJ8NTQ4tGNZHgQ","cls2":"p6D7a7AeDcabty_uxT3w FWhglUeJ8NTQ4tGNZHgQ","isTabletDown":"XsEkzO3wtLrzzCSzb_9o"};